import styled from "styled-components";

export const Wrapper = styled("div")(({ theme, $isShowInSmallScreen }) => ({
  ...theme.mixins.flexAlignCenter,
  ...theme.paddings(24),
  justifyContent: "space-between",
  display: $isShowInSmallScreen ? "none" : "flex",
  width: "100%",
  gap: 30,
  backgroundColor: theme.palette.white,
  borderRadius: 8,
  boxShadow: `0 2px 8px ${theme.palette.shadow.medium}`,
  border: "1px solid #f0f0f0",

  [theme.down("lg")]: {
    display: $isShowInSmallScreen ? "flex" : "none",
  },

  [theme.down("sm")]: {
    ...theme.paddings(20, 15),
  },

  [theme.down("xs")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 10,
  },
}));

export const InfoBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  gap: 30,

  [theme.down("xs")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 10,
  },
}));

export const ItemTitle = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  fontWeight: 500,
  marginBottom: 4,
}));

export const ItemValue = styled("div")(({ theme }) => ({
  fontSize: 18,
  color: theme.palette.text.primary,
  fontWeight: 600,

  "& .order-id": {
    display: "flex",
    padding: "2px 5px",
    color: theme.palette.white,
    backgroundColor: "#358ed3",
    fontSize: 16,
  },

  [theme.down("sm")]: {
    fontSize: 16,
  },

  [theme.down("xs")]: {
    fontSize: 15,
  },
}));

export const DownloadBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  justifyContent: "flex-end",

  position: "relative",
  zIndex: 2,

  [theme.down("xs")]: {
    width: "100%",
  },
}));

export const DownloadButton = styled("button")(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: "50%",
  border: `2px solid ${theme.palette.header.border}`,
  padding: 0,
  margin: 0,
  color: theme.palette.header.primary,
  backgroundColor: theme.palette.header.primaryLight,
  fontSize: 24,
  cursor: "pointer",
  transition: "all .2s ease",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: `0 2px 4px ${theme.palette.header.shadow}`,

  "&:hover": {
    backgroundColor: theme.palette.header.primary,
    color: theme.palette.white,
    borderColor: theme.palette.header.primary,
    transform: "translateY(-2px)",
    boxShadow: `0 4px 8px ${theme.palette.header.primaryShadow}`,
  },

  "&:active": {
    transform: "translateY(0)",
  },

  [theme.down("sm")]: {
    width: 44,
    height: 44,
    fontSize: 22,
  },
}));

export const Tooltip = styled("div")(({ theme }) => ({
  position: "absolute",
  bottom: "calc(100% + 12px)",
  left: "50%",
  transform: "translateX(-50%)",
  backgroundColor: theme.palette.header.text,
  color: theme.palette.white,
  padding: "8px 12px",
  borderRadius: 6,
  fontSize: 13,
  fontWeight: 500,
  whiteSpace: "nowrap",
  pointerEvents: "none",
  opacity: 0,
  visibility: "hidden",
  transition: "opacity .2s ease, visibility .2s ease, transform .2s ease",
  zIndex: 1000,
  boxShadow: `0 4px 12px ${theme.palette.header.dropdownShadow}`,

  "&::after": {
    content: '""',
    position: "absolute",
    top: "100%",
    left: "50%",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderTop: `6px solid ${theme.palette.header.text}`,
  },

  [theme.down("sm")]: {
    fontSize: 12,
    padding: "6px 10px",
  },
}));
